import { useRef } from "react";

function ViewPopupContent(props:any) {
  //props.rowData.a_user_name;
  const downloadFormRef=useRef(null);
  const imgStyle={
    maxWidth:"100%"
  };

  const goDownLoad=()=>{
    let pri_val=props.rowData.a_ymd+","+props.rowData.a_seq;
    if(downloadFormRef.current==null){return false;}
    let downloadForm=downloadFormRef.current as HTMLFormElement;
    downloadForm.action=props.rowData["a_serverurl"]+"/api/file/download/"+pri_val;
    downloadForm.submit();
  };

  return (
    <div>
      <div className="view-table-div mt-2">
        <table>
          <colgroup>
            <col width="20%"></col>
            <col width="80%"></col>
          </colgroup>
          <tbody>
            <tr>
              <td colSpan={2}>
                <div className="text-center">
                  {props.rowData.is_image=="1" &&
                    <a href="#" onClick={()=>{window.open(props.rowData.img_url);}}>
                      <img src={props.rowData.img_url} style={imgStyle} />
                    </a>
                  }
                </div>
              </td>
            </tr>
            <tr>
              <th>다운로드</th>
              <td>
                  <button className="btn btn-blue" onClick={()=>{goDownLoad();}} >다운로드</button>
                  <form id="download_form" ref={downloadFormRef} method="post" >
                    <input type="hidden" name="authorization" value={localStorage.intoyou_token} />
                  </form>
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>{props.rowData.a_oriname}</td>
            </tr>
            <tr>
              <th>크기</th>
              <td>{props.rowData.a_size}</td>
            </tr>
            <tr>
              <th>작성일</th>
              <td>{props.rowData.a_create_date}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-box-center mt-2">
        <button className="btn btn-line-gray" onClick={()=>{props.closePopup();}}>닫기</button>
      </div>
    </div>
  );
}

export default ViewPopupContent;
